
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/resources/risk-based-pricing-laws-and-regulations",
      function () {
        return require("private-next-pages/compliance/resources/risk-based-pricing-laws-and-regulations.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/resources/risk-based-pricing-laws-and-regulations"])
      });
    }
  